'use client';
import { useSession } from '#pplx/frontend/auth/useSession.js';
export const useSessionOrgUUID = () => {
    const { session } = useSession();
    const orgUUID = session?.user?.org_uuid;
    // orgUUID is set to 'none' when its value is undefined.
    // This enables caching of the value when user is not in an organization.
    return { uuid: orgUUID === 'none' ? undefined : orgUUID };
};
//# sourceMappingURL=useSessionOrgUUID.js.map